// 찜질방 배치: 구역 5개, 구역 사이 문, 열탕·냉탕, 아기 놀이터, 매점, 2층 데크. 프로토타입 2808–2830.
// three.js를 쓰지 않는 순수 TS (나중에 서버에서도 같은 배치를 쓴다).
import type { NavConfig } from '../../engine/nav';

export type JArea = 'hall' | 'bath' | 'hwangto' | 'salt' | 'ice';
/** name·ko: 문 위 표지판 글씨. */
export interface AreaRect { x0: number; x1: number; z0: number; z1: number; h: number; name: string; ko: string }
interface P { x: number; z: number }

/** 벽 장식 높이 기준 (프로토타입 JW_Y). */
export const JW_Y = 0.35;

export const JAREA: Record<JArea, AreaRect> = {
  hall: { x0: -22, x1: 22, z0: -14, z1: 16, h: 6.2, name: 'Main hall', ko: '메인 홀' },
  bath: { x0: -43, x1: -19, z0: -46, z1: -22, h: 4.8, name: 'Bathhouse', ko: '목욕탕' },
  hwangto: { x0: -15, x1: 1, z0: -40, z1: -26, h: 4.6, name: 'Hwangto clay room', ko: '황토방' },
  salt: { x0: 5, x1: 21, z0: -40, z1: -26, h: 4.6, name: 'Salt room', ko: '소금방' },
  ice: { x0: 25, x1: 41, z0: -38, z1: -26, h: 4.6, name: 'Ice room', ko: '얼음방' },
};
export const AREAS = Object.keys(JAREA) as JArea[];

/** 메인 홀 북쪽 벽의 문 4개. hallP·roomP: 문 양쪽 바로 앞, hallIn·roomIn: 들어간 뒤 설 곳. */
export interface JDoor { area: Exclude<JArea, 'hall'>; hx: number; hallP: P; roomP: P; hallIn: P; roomIn: P }
export const JDOORS: JDoor[] = ([['bath', -16], ['hwangto', -8], ['salt', 0], ['ice', 8]] as const).map(([area, hx]) => {
  const A = JAREA[area], cx = (A.x0 + A.x1) / 2;
  return { area, hx, hallP: { x: hx, z: JAREA.hall.z0 + 0.3 }, roomP: { x: cx, z: A.z1 - 0.3 }, hallIn: { x: hx, z: JAREA.hall.z0 + 1.9 }, roomIn: { x: cx, z: A.z1 - 1.9 } };
});

export interface Tub { x0: number; x1: number; z0: number; z1: number; col: number }
export const TUBS: Record<'hot' | 'cold', Tub> = {
  hot: { x0: -30.5, x1: -21.5, z0: -42.5, z1: -35.5, col: 0x7FCFDB },
  cold: { x0: -30.5, x1: -22.5, z0: -31.8, z1: -26.2, col: 0x6AAEE8 },
};

/** 아기 전용 놀이터: 트램펄린, 볼풀, 미끄럼틀. 문은 남쪽 울타리의 gate. */
export const PLAY = {
  x0: -21.6, x1: -10, z0: 8, z1: 15.6, gate: { x: -11, z: 7.0 },
  tramp: { x: -19.2, z: 12, r: 1.5 }, pit: { x0: -15.2, x1: -11.8, z0: 10, z1: 14.6 }, slide: { x: -16.4, z0: 9.6, z1: 14.2 },
} as const;
export const SHOP = { order: { x: 17.6, z: -11.6 } } as const;
/** 동쪽 벽의 2층 데크 (아래는 아치형 굴방 4칸). 계단은 북쪽 끝. */
export const JDECK = { x0: 18, x1: 22, z0: -1, z1: 15, H: 2.4, stairBot: { x: 20, z: -5.4 }, stairTop: { x: 20, z: -0.5 } } as const;
/** 굴방 4칸 자리 (보행 격자에서 칸 사이 벽을 막는다). */
export const CUBBY_RECT = [JDECK.x0, JDECK.x1, JDECK.z0, JDECK.z1] as const;

export const JNAV: NavConfig = { x0: -44, z0: -48, cs: 0.5, nx: 176, nz: 176 };

export function areaAt(x: number, z: number): JArea {
  for (const k of AREAS) { const A = JAREA[k]; if (x >= A.x0 - 0.5 && x <= A.x1 + 0.5 && z >= A.z0 - 0.5 && z <= A.z1 + 0.5) return k; }
  return 'hall';
}
export const inTub = (T: Tub, x: number, z: number, inset = 0): boolean => x > T.x0 + inset && x < T.x1 - inset && z > T.z0 + inset && z < T.z1 - inset;
/** 탕 물에 잠기는 정도 0~1 (가장자리에서 서서히). */
export function jjimWet(x: number, z: number): number {
  for (const T of [TUBS.hot, TUBS.cold]) {
    if (inTub(T, x, z, 0)) { const e = Math.min(x - T.x0, T.x1 - x, z - T.z0, T.z1 - z); return Math.max(0, Math.min(1, (e - 0.2) / 0.6)); }
  }
  return 0;
}
export const inPlay = (x: number, z: number): boolean => x > PLAY.x0 && x < PLAY.x1 && z > PLAY.z0 && z < PLAY.z1;
